module.exports = __webpack_public_path__ + "media/red-truck.43c0e16c.svg";